// extracted by mini-css-extract-plugin
export default {"note":"TariffActivationWindow_note__+mYXa","btnGroup":"TariffActivationWindow_btnGroup__f6cJj"};